/* Création Medina — theme.js */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const routes = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };

  /* ---------- Sticky header ---------- */
  const header = $('.site-header');
  const setStickyTop = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--sticky-top', header.offsetHeight + 'px');
  };
  setStickyTop();
  window.addEventListener('resize', setStickyTop);
  window.addEventListener('scroll', () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 10);
  }, { passive: true });

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const f = d.querySelector('button, a, input');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); return; }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      const sb = $('.search-bar.is-open');
      if (sb) sb.classList.remove('is-open');
    }
  });

  /* ---------- Search bar ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-toggle-search]');
    if (!t) return;
    e.preventDefault();
    const bar = $('.search-bar');
    if (!bar) return;
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) $('input', bar).focus();
  });

  /* ---------- Language switcher ---------- */
  $$('.lang-form select').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  $$('.reveal').forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));

  /* ---------- Cart (Section Rendering API) ---------- */
  const CART_SECTION = 'cart-drawer';

  function renderCart(sections) {
    if (!sections || !sections[CART_SECTION]) return;
    const doc = new DOMParser().parseFromString(sections[CART_SECTION], 'text/html');
    const fresh = doc.querySelector('#CartDrawerInner');
    const current = $('#CartDrawerInner');
    if (fresh && current) current.replaceWith(fresh);
    const count = doc.querySelector('[data-cart-count-source]');
    if (count) $$('.cart-count').forEach((c) => { c.textContent = count.dataset.cartCountSource; c.dataset.count = count.dataset.cartCountSource; });
  }

  async function cartChange(line, quantity) {
    const inner = $('#CartDrawerInner');
    if (inner) inner.classList.add('is-loading');
    try {
      const res = await fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: [CART_SECTION] })
      });
      const data = await res.json();
      if (document.body.dataset.template === 'cart') { window.location.reload(); return; }
      renderCart(data.sections);
    } catch (err) {
      console.error(err);
      if (inner) inner.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (btn) {
      e.preventDefault();
      const line = parseInt(btn.dataset.line, 10);
      const input = btn.parentElement.querySelector('input');
      const q = Math.max(0, parseInt(input.value, 10) + parseInt(btn.dataset.cartQty, 10));
      cartChange(line, q);
      return;
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); cartChange(parseInt(rm.dataset.line, 10), 0); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    if (input) cartChange(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    const err = form.querySelector('[data-form-error]');
    if (btn) btn.classList.add('is-loading');
    if (err) err.hidden = true;
    const fd = new FormData(form);
    fd.append('sections', CART_SECTION);
    fd.append('sections_url', window.location.pathname);
    try {
      const res = await fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (data.status) {
        if (err) { err.textContent = data.description || data.message; err.hidden = false; }
        return;
      }
      renderCart(data.sections);
      openDrawer('CartDrawer');
    } catch (e2) {
      form.submit();
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || document.body.dataset.cartType === 'page') return;
    e.preventDefault();
    addToCart(form);
  });

  /* ---------- Quantity pickers (product page) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = $('form[data-ajax-cart]', root);
    const idInput = form ? $('input[name="id"]', form) : null;
    const priceEl = $('[data-price]', root);
    const atc = $$('[data-atc]', root);
    const slides = $('.pdp__slides', root);
    const thumbs = $$('.pdp__thumbs button', root);
    const dots = $$('.pdp__dots span', root);

    const goTo = (index, smooth = true) => {
      if (!slides) return;
      const slide = slides.children[index];
      if (!slide) return;
      slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      thumbs.forEach((t, i) => t.setAttribute('aria-current', i === index ? 'true' : 'false'));
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    if (slides) {
      slides.addEventListener('scroll', () => {
        const i = Math.round(Math.abs(slides.scrollLeft) / slides.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
        thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
      }, { passive: true });
    }

    const selected = () => $$('.option', root).map((fs) => {
      const c = $('input:checked', fs);
      return c ? c.value : null;
    });

    const update = () => {
      const opts = selected();
      $$('.option', root).forEach((fs, i) => {
        const lbl = $('legend span', fs);
        if (lbl) lbl.textContent = opts[i] || '';
      });
      const v = data.variants.find((x) => x.options.every((o, i) => o === opts[i]));
      // availability hints
      $$('.option', root).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const ok = data.variants.some((x) => x.available && x.options.every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !ok);
        });
      });
      atc.forEach((b) => {
        const label = $('[data-atc-label]', b) || b;
        if (!v) { b.disabled = true; label.textContent = data.strings.unavailable; }
        else if (!v.available) { b.disabled = true; label.textContent = data.strings.soldOut; }
        else { b.disabled = false; label.textContent = data.strings.addToCart; }
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl && data.prices[v.id]) priceEl.innerHTML = data.prices[v.id];
      if (v.media_index != null) goTo(v.media_index);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    $$('.option input', root).forEach((i) => i.addEventListener('change', update));
    update();

    /* sticky add to cart on mobile */
    const sticky = $('.sticky-atc');
    const mainBtn = form ? $('[type="submit"]', form) : null;
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainBtn);
      const sb = $('button', sticky);
      if (sb) sb.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) {
        el.innerHTML = inner.innerHTML;
        $$('.reveal', el).forEach((r) => r.classList.add('is-in'));
      }
    } catch (e) { /* silencieux */ }
  });

  /* ---------- Collection: sort & filters ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));
  $$('form[data-filters]').forEach((f) => {
    f.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox') f.submit();
    });
  });

  /* ---------- Essayage virtuel : libellé du bouton ---------- */
  const vtoLabel = (document.documentElement.lang || 'fr').startsWith('ar') ? 'جرّبيها عليك' : (document.documentElement.lang || 'fr').startsWith('en') ? 'Try it on me' : 'Essayer sur moi';
  const fixVto = () => $$('.vto-injected-button').forEach((b) => { if (b.textContent.trim() !== vtoLabel) b.textContent = vtoLabel; });
  fixVto();
  new MutationObserver(fixVto).observe(document.body, { childList: true, subtree: true });
})();
